import { Typography, useTheme } from "@mui/material";
import { createPlot } from "../utils/plotUtils";

export const PricingHealthDetailChart = ({ selectedMetric }) => {
  const theme = useTheme();
  const dims = theme.dimensions;
  const panelTheme = theme.palette.contentPanel;

  if (!selectedMetric) {
    return null;
  }

  const renderPriceRealizationChart = () => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const unitPrice = [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100];
    const unitVCOGS = [82, 80, 83, 85, 84, 86, 85, 87, 88, 86, 85, 87];
    const variableMargin = [200, 210, 205, 215, 205, 215, 205, 210, 210, 215, 205, 210];

    return createPlot([
      {
        x: months,
        y: unitPrice,
        type: "scatter",
        mode: "lines",
        fill: "tonexty",
        fillcolor: "rgba(161, 209, 255, 0.6)",
        line: { color: "#108AEF", width: 3 },
        name: "Unit Price Avg",
        yaxis: "y",
        hovertemplate: "Unit Price: $%{y:.2f}<extra></extra>"
      },
      {
        x: months,
        y: unitVCOGS,
        type: "scatter",
        mode: "lines",
        fill: "tozeroy",
        fillcolor: "rgba(169, 169, 169, 0.6)",
        line: { color: "#000080", width: 3 },
        name: "VCOGS/Unit",
        yaxis: "y",
        hovertemplate: "Unit VCOGS: $%{y:.2f}<extra></extra>"
      },
      {
        x: months,
        y: variableMargin,
        type: "scatter",
        mode: "lines",
        fill: "tonexty",
        fillcolor: "rgba(244, 195, 177, 0.6)",
        line: { color: "#FF6347", width: 3 },
        name: "Variable Margin/Unit",
        yaxis: "y2",
        hovertemplate: "Pocket Margin: $%{y:.2f}<extra></extra>"
      }
    ], {
      yaxis: {
        title: "Unit Price Avg",
        side: "left",
        showgrid: true,
        tickformat: "$,.0f"
      },
      yaxis2: {
        title: "Unit Variable Margin",
        side: "right",
        overlaying: "y",
        showgrid: false,
        tickformat: "$,.0f"
      },
      xaxis: { title: "Month" },
      showlegend: true,
      legend: { 
        orientation: "h", 
        y: 1.15,
        x: 0,
        bgcolor: "rgba(255,255,255,0.8)"
      },
      width: 500,
      margin: { t: 30, b: 30, l: 30, r: 40 }
    });
  };

  const renderCostPassThruChart = () => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const unitPrice = [500, 520, 510, 530, 525, 540, 535, 545, 550, 560, 555, 565];
    const unitVCOGS = [300, 310, 305, 315, 320, 325, 330, 335, 340, 345, 350, 355];
    const variableMargin = [200, 210, 205, 215, 205, 215, 205, 210, 210, 215, 205, 210];

    return createPlot([
      {
        x: months,
        y: unitPrice,
        type: "scatter",
        mode: "lines",
        fill: "tonexty",
        fillcolor: "rgba(161, 209, 255, 0.6)",
        line: { color: "#108AEF", width: 3 },
        name: "Unit Price Avg",
        yaxis: "y",
        hovertemplate: "Unit Price: $%{y:.2f}<extra></extra>"
      },
      {
        x: months,
        y: unitVCOGS,
        type: "scatter",
        mode: "lines",
        fill: "tozeroy",
        fillcolor: "rgba(169, 169, 169, 0.6)",
        line: { color: "#000080", width: 3 },
        name: "VCOGS/Unit",
        yaxis: "y",
        hovertemplate: "Unit VCOGS: $%{y:.2f}<extra></extra>"
      },
      {
        x: months,
        y: variableMargin,
        type: "scatter",
        mode: "lines",
        fill: "tonexty",
        fillcolor: "rgba(244, 195, 177, 0.6)",
        line: { color: "#FF6347", width: 3 },
        name: "Variable Margin/Unit",
        yaxis: "y2",
        hovertemplate: "Pocket Margin: $%{y:.2f}<extra></extra>"
      }
    ], {
      yaxis: {
        title: "Unit Price Avg",
        side: "left",
        showgrid: true,
        tickformat: "$,.0f"
      },
      yaxis2: {
        title: "Unit Variable Margin",
        side: "right",
        overlaying: "y",
        showgrid: false,
        tickformat: "$,.0f"
      },
      xaxis: { title: "Month" },
      showlegend: true,
      legend: { 
        orientation: "h", 
        y: 1.15,
        x: 0,
        bgcolor: "rgba(255,255,255,0.8)"
      },
      width: 500,
      margin: { t: 30, b: 30, l: 30, r: 40 }
    });
  };

  const renderFreightRecoveryChart = () => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const unitPrice = [50, 52, 51, 53, 54, 55, 54, 56, 57, 56, 55, 57];
    const unitVCOGS = [44, 47, 45, 48, 50, 51, 49, 52, 54, 52, 51, 54];
    const variableMargin = [200, 210, 205, 215, 205, 215, 205, 210, 210, 215, 205, 210];

    return createPlot([
      {
        x: months,
        y: unitPrice,
        type: "scatter",
        mode: "lines",
        fill: "tonexty",
        fillcolor: "rgba(161, 209, 255, 0.6)",
        line: { color: "#108AEF", width: 3 },
        name: "Unit Price Avg",
        yaxis: "y",
        hovertemplate: "Unit Price: $%{y:.2f}<extra></extra>"
      },
      {
        x: months,
        y: unitVCOGS,
        type: "scatter",
        mode: "lines",
        fill: "tozeroy",
        fillcolor: "rgba(169, 169, 169, 0.6)",
        line: { color: "#000080", width: 3 },
        name: "VCOGS/Unit",
        yaxis: "y",
        hovertemplate: "Unit VCOGS: $%{y:.2f}<extra></extra>"
      },
      {
        x: months,
        y: variableMargin,
        type: "scatter",
        mode: "lines",
        fill: "tonexty",
        fillcolor: "rgba(244, 195, 177, 0.6)",
        line: { color: "#FF6347", width: 3 },
        name: "Variable Margin/Unit",
        yaxis: "y2",
        hovertemplate: "Pocket Margin: $%{y:.2f}<extra></extra>"
      }
    ], {
      yaxis: {
        title: "Unit Price Avg",
        side: "left",
        showgrid: true,
        tickformat: "$,.0f"
      },
      yaxis2: {
        title: "Unit Variable Margin",
        side: "right",
        overlaying: "y",
        showgrid: false,
        tickformat: "$,.0f"
      },
      xaxis: { title: "Month" },
      showlegend: true,
      legend: { 
        orientation: "h", 
        y: 1.15,
        x: 0,
        bgcolor: "rgba(255,255,255,0.8)"
      },
      width: 500,
      margin: { t: 30, b: 30, l: 30, r: 40 }
    });
  };

  const getChartTitle = () => {
    switch (selectedMetric) {
      case 'priceRealization':
        return 'Price Realization';
      case 'costPassThruRate':
        return 'Cost Pass-Thru Rate';
      case 'freightRecoveryRate':
        return 'Freight Recovery Rate';
      default:
        return '';
    }
  };

  const renderChart = () => {
    switch (selectedMetric) {
      case 'priceRealization':
        return renderPriceRealizationChart();
      case 'costPassThruRate':
        return renderCostPassThruChart();
      case 'freightRecoveryRate':
        return renderFreightRecoveryChart();
      default:
        return null;
    }
  };

  return (
    <div style={{ ...panelTheme, marginTop: 30, padding: 10, width: '100%', minHeight: dims.smallPanelHeight}}>
      <Typography variant="h5" display="inline" style={{marginLeft: 10}}>
        {getChartTitle()}
      </Typography>
      {renderChart()}
    </div>
  );
};
